// external libs
import * as pdx from 'up.lib.js.pdx';
import checkSchema from './validator';

// constants
import {
  EC_SYS,
  EC_USER,
  EA_LAUNCH,
  EA_CHECK,
  EA_HOLD,
  EA_ENABLE,
  EA_SELECT,
  EA_MOUSEUP,
  EA_SHOW,
  EA_OPEN,
  EA_CLOSE,
  EA_ERROR,
  EA_DISABLE,
  EA_LOAD,
  EA_CHANGE,
  EA_GET,
  EA_REPLACE,
  EA_POST,
  EA_POST_RESULT,
  EA_INIT,
  EA_CART,
  EA_WARN,
  EL_MWEB,
  EL_PAGE,
  EL_PREREQS,
  EL_PAY_MONTHLY,
  EL_PAYMENT,
  EL_UPLIFT_PAYMENTS,
  EL_ORDER_CREATE,
  EL_ORDER_UPDATE,
  EL_CARD,
  EL_BOOKING,
  EL_VALIDATION,
  EL_PAY_IN_FULL,
  EL_ORDER_INFO,
  EL_FROM_PRICES,
  EL_CID,
  EL_COMPLETE,
  EL_HOTEL,
  EL_SEARCH,
  EL_CONTAINER,
  EL_MODAL,
  EL_LIGHTBOX,
  EL_LIGHTBOX_FAQ,
  EL_LIGHTBOX_QUESTION,
  EL_TOOLTIP,
  EL_ROOM_UPGRADE,
  EL_PLACE_ORDER,
  EL_CHECKOUT,
  EL_VERSION_MISMATCH,
  EL_PROMO,
  EL_PERSISTENCE,
  EL_LOCALE,
  EL_CURRENCY,
  EL_API,
  EL_IFRAME,
  EV_RAW,
  EV_RESULT,
  EV_VERSION,
  EV_MERCHANT,
  EV_REASON,
  EV_VALUE,
  EV_FROM,
  EV_LOCALIZATION,
  EV_ORDER_ID,
  EV_MESSAGE,
  EV_PAGE,
  EV_BUILD,
  EV_ORIGIN,
  EV_ORDER_AMOUNT,
  EV_STATUS,
  EV_MSG,
  K_DEBUG,
  K_OK,
  K_FAIL,
  K_LEVEL,
  K_DEFAULT_EV,
  K_CLICK, K_PRICING, K_PRICING_BASE,
  REASON_OUT_OF_FILTER,
  R_SHOW_IFRAME,
  R_MCODE,
  EV_PROMO_ID,
  EV_PROMO_AVAILABLE,
  EV_QUERY
} from './constants';

function Locale() {
  const localization = {
    country: 'US',
    language: 'en',
    currency: 'USD'
  };
  return {
    getLocale() {
        return localization;
    },
    setCountry(val)
    {
      localization.country = val;
    },
    setLanguage(val)
    {
      localization.language = val;
    },
    setCurrency(val)
    {
      localization.currency = val;
    }
  }
}

export const localization = new Locale();

export function debugRaw(ec, ea, el, ev) {
    pdx.debug(ec, ea, el, ev);
}

export function debugCustom(ev) {
    pdx.debug(EC_SYS, K_DEBUG, EV_RAW, ev);
}

export function debugTryCatch(ev) {
    pdx.info(EC_SYS, K_DEBUG, EV_RAW, ev);
}

export function debugReadPersistence(msg) {
  const ev = {};
  ev[EV_MSG] = msg;
  pdx.info(EC_SYS, K_DEBUG, EL_PERSISTENCE, ev);
}

export function setLevel(level) {
    pdx.set(K_LEVEL, level);
}

export function setMwebVersion(version) {
    pdx.set(K_DEFAULT_EV, {'mweb': version});
}

export function setApiVersion(version) {
    pdx.set(K_DEFAULT_EV, {'up.lib.js.payments': version});
}

export function debugInit() {
    pdx.debug(EC_SYS, EA_INIT, EL_UPLIFT_PAYMENTS);
}

export function sendWarn(ev) {
  pdx.debug(EC_SYS, EA_WARN, EL_VERSION_MISMATCH, ev);
}

export function errorNoContainer(msg) {
    let ev = {};
    ev[EV_MSG] = msg;
    pdx.error(EC_SYS, EA_CHECK, EL_CONTAINER, ev);
}

export function sendLaunch(version, merchantVersion = '') {
    let ev = {};
    ev[EV_RESULT] = K_OK;
    ev[EV_VERSION] = version;
    if (merchantVersion !== '') {
        ev[EV_MERCHANT] = merchantVersion;
    }

    // send launch event with all versions
    pdx.info(EC_SYS, EA_LAUNCH, EL_MWEB, ev);
}

export function sendPrereqsOk() {
    let ev = {};
    ev[EV_RESULT] = K_OK;
    pdx.debug(EC_SYS, EA_CHECK, EL_PREREQS, ev);
}

export function sendPrereqsFail(result) {
    let ev = {};
    ev[EV_RESULT] = K_FAIL;
    ev[EV_REASON] = result;
    pdx.warn(EC_SYS, EA_CHECK, EL_PREREQS, ev);
}

export function pmEnabled(fromPricingAmount) {
    let ev = {};
    ev[EV_FROM] = fromPricingAmount;
    pdx.info(EC_SYS, EA_ENABLE, EL_PAY_MONTHLY, ev);
}

export function pmDisabled(reasons) {
    let ev = {};
    ev[EV_REASON] = reasons;
    pdx.info(EC_SYS, EA_DISABLE, EL_PAY_MONTHLY, ev);
}

export function bookingError(message) {
    let ev = {};
    ev[EV_MESSAGE] = message;
    pdx.warn(EC_SYS, EA_ERROR, EL_BOOKING, ev);
}

export function validationError(message) {
    let ev = {};
    ev[EV_MESSAGE] = message;
    pdx.warn(EC_SYS, EA_ERROR, EL_VALIDATION, ev);
}

export function fillCreditCardFormFail(fields) {
  let ev = {};
  ev[EV_REASON] = fields;
  pdx.warn(EC_SYS, K_DEBUG, EL_BOOKING, ev);
}

export function pmSelect() {
    let ev = {};
    ev[EV_VALUE] = EL_PAY_MONTHLY;
    pdx.info(EC_USER, EA_SELECT, EL_PAYMENT, ev);
}

export function pmDeselect(custom=EL_PAY_IN_FULL) {
    let ev = {};
    ev[EV_VALUE] = custom;
    pdx.info(EC_USER, EA_SELECT, EL_PAYMENT, ev);
}

export function unmatchedLocale() {
  let ev = {};
  ev[EV_RESULT] = K_FAIL;
  pdx.info(EC_SYS, K_DEBUG, EL_LOCALE, ev);
}

export function unmatchedCurrency() {
  let ev = {};
  ev[EV_RESULT] = K_FAIL;
  pdx.info(EC_SYS, K_DEBUG, EL_CURRENCY, ev);
}

export function localeOutOfScope(ev) {
  pdx.info(EC_SYS, EA_WARN, EL_LOCALE, ev);
}

export function currencyOutOfScope(ev) {
  pdx.info(EC_SYS, EA_WARN, EL_CURRENCY, ev);
}

export function outOfFilter(orderID) {
    let ev = {};
    ev[EV_REASON] = REASON_OUT_OF_FILTER;
    ev[EV_ORDER_ID] = orderID;
    pdx.info(EC_SYS, EA_DISABLE, EL_PAY_MONTHLY, ev);
}

export function noOffer() {
    let ev = {};
    ev[EV_RESULT] = K_FAIL;
    ev[EV_REASON] = R_SHOW_IFRAME + ':false';
    pdx.warn(EC_SYS, EA_LOAD, EL_UPLIFT_PAYMENTS, ev);
}

export function noOfferBecause(reason) {
    let ev = {};
    ev[EV_RESULT] = K_FAIL;
    ev[EV_REASON] = reason;
    pdx.warn(EC_SYS, EA_LOAD, EL_UPLIFT_PAYMENTS, ev);
}

export function loanNotConfirmed() {
    let ev = {};
    ev[EV_RESULT] = K_FAIL;
    ev[EV_RESULT] = 'loan is not yet confirmed';
    pdx.warn(EC_USER, EA_MOUSEUP, EL_UPLIFT_PAYMENTS, ev);
}

export function initOrderFail(reason) {
    let ev = {};
    ev[EV_RESULT] = K_FAIL;
    ev[EV_REASON] = reason;
    pdx.warn(EC_SYS, EA_ERROR, EL_ORDER_INFO, ev);
}


export function fromPricingRequest(request) {
    let ev = {};
    ev[EV_MSG] = request;
    ev[EV_LOCALIZATION] = (localization.getLocale()) ? localization.getLocale() : Locale().getLocale();
    pdx.info(EC_SYS, EA_POST, EL_FROM_PRICES, ev);
}

export function fromPricingSuccess(response) {
    let ev = {};
    ev[EV_RESULT] = response;
    ev[EV_LOCALIZATION] = (localization.getLocale()) ? localization.getLocale() : Locale().getLocale();
    pdx.info(EC_SYS, EA_POST_RESULT, EL_FROM_PRICES, ev);
}

export function fromPricingFail(reason, page = null) {
    let ev = {};
    ev[EV_LOCALIZATION] = (localization.getLocale()) ? localization.getLocale() : Locale().getLocale();
    ev[EV_RESULT] = K_FAIL;
    ev[EV_REASON] = reason;
    if (page !== null) {
        ev[EV_PAGE] = page;
    }
    pdx.info(EC_SYS, EA_POST_RESULT, EL_FROM_PRICES, ev);
}

export function isPromoCalled(id, isAvailable) {
    let ev = {};
    ev[EV_PROMO_ID] = id;
    ev[EV_PROMO_AVAILABLE] = isAvailable;
    pdx.info(EC_SYS, EA_CHECK, EL_PROMO, ev);
}

export function debugLoadIframe(sessionID, build, origin) {
    let ev = {};
    ev[EV_ORDER_ID] = sessionID;
    ev[EV_BUILD] = build;
    ev[EV_ORIGIN] = origin;
    pdx.debug(EC_SYS, EA_GET, EA_LOAD, ev);
}

export function postCreateOrder(orderID, orderAmount, mcode) {
    let ev = {};
    if (orderID !== null) {
        ev[EV_ORDER_ID] = orderID;
    }
    ev[R_MCODE] = mcode;
    ev[EV_ORDER_AMOUNT] = orderAmount;
    pdx.debug(EC_SYS, EA_POST, EL_ORDER_CREATE, ev);
}

export function postCreateResult(orderID, status, mcode) {
    let ev = {};
    ev[EV_ORDER_ID] = orderID;
    ev[EV_STATUS] = status;
    ev[R_MCODE] = mcode;
    pdx.debug(EC_SYS, EA_POST_RESULT, EL_ORDER_CREATE, ev);
}

export function postUpdateOrder(orderID, orderAmount, mcode) {
    let ev = {};
    if (orderID !== null) {
        ev[EV_ORDER_ID] = orderID;
    }
    ev[EV_ORDER_AMOUNT] = orderAmount;
    ev[R_MCODE] = mcode;
    pdx.debug(EC_SYS, EA_POST, EL_ORDER_UPDATE, ev);
}

export function postUpdateResult(orderID, status, mcode) {
    let ev = {};
    ev[EV_ORDER_ID] = orderID;
    ev[EV_STATUS] = status;
    ev[R_MCODE] = mcode;
    pdx.debug(EC_SYS, EA_POST_RESULT, EL_ORDER_UPDATE, ev);
}

export function debugGetCard(result) {
    let ev = {};
    ev[EV_RESULT] = result;
    pdx.debug(EC_SYS, EA_GET, EL_CARD, ev);
}

export function modalClick(pricing, pricingBase) {
    const ev = {};
    if (pricing) {
        ev[K_PRICING] = pricing;
    }
    if (pricingBase) {
        ev[K_PRICING_BASE] = pricingBase;
    }
    pdx.info(EC_USER, EA_SHOW, EL_MODAL, ev);
}

export function lightboxInit(ev) {
  ev[EV_LOCALIZATION] = (localization.getLocale()) ? localization.getLocale() : Locale().getLocale();
  pdx.info(EC_SYS, EA_INIT, EL_LIGHTBOX, ev);
}

export function lightboxShow(ev) {
  ev[EV_LOCALIZATION] = (localization.getLocale()) ? localization.getLocale() : Locale().getLocale();
  pdx.info(EC_USER, EA_SHOW, EL_LIGHTBOX, ev);
}

export function lightboxOpen(ev) {
  ev[EV_LOCALIZATION] = (localization.getLocale()) ? localization.getLocale() : Locale().getLocale();
  pdx.info(EC_SYS, EA_OPEN, EL_LIGHTBOX, ev);
}

export function lightboxClose(ev) {
  ev[EV_LOCALIZATION] = (localization.getLocale()) ? localization.getLocale() : Locale().getLocale();
  pdx.info(EC_USER, EA_CLOSE, EL_LIGHTBOX, ev);
}

export function faqShow(ev) {
  ev[EV_LOCALIZATION] = (localization.getLocale()) ? localization.getLocale() : Locale().getLocale();
  pdx.info(EC_USER, EA_SHOW, EL_LIGHTBOX_FAQ, ev);
}

export function questionShow(ev) {
  ev[EV_LOCALIZATION] = (localization.getLocale()) ? localization.getLocale() : Locale().getLocale();
  pdx.info(EC_USER, EA_SHOW, EL_LIGHTBOX_QUESTION, ev);
}

export function tooltipOpen(ev) {
  ev[EV_LOCALIZATION] = (localization.getLocale()) ? localization.getLocale() : Locale().getLocale();
  pdx.info(EC_USER, EA_SHOW, EL_TOOLTIP, ev);
}

export function userPlaceOrder() {
    pdx.info(EC_USER, K_CLICK, EL_PLACE_ORDER);
}

export function userSearch(ev) {
    pdx.info(EC_USER, EA_CART, EL_SEARCH, ev);
}

export function userCartHotel(ev) {
    pdx.info(EC_USER, EA_CART, EL_HOTEL, ev);
}

export function userNumPayments(ev) {
    pdx.info(EC_USER, K_CLICK, EL_COMPLETE, ev);
}

export function userUpgradeRoom(ev) {
    pdx.info(EC_USER, K_CLICK, EL_ROOM_UPGRADE, ev);
}

export function userCheckoutPromocode(promocode) {
    pdx.info(EC_USER, EA_CART, EL_CHECKOUT, {promocode});
}

export function replaceCID(ev) {
    pdx.info(EC_SYS, EA_REPLACE, EL_CID, ev);
}

export function holdBooking(payload) {
    pdx.info(EC_SYS, EA_HOLD, EL_BOOKING, {payload});
}

export function userLoadPage(ev) {
    pdx.info(EC_USER, EA_LOAD, EL_PAGE, ev);
}

export function sendSubmit(data){
    checkSchema(data);
    pdx.transaction({subtype : 'submit',
                     data : data});
}

export function sendResponse(data){
    pdx.transaction({subtype : 'response',
                     data : data});
}

export function sendPending(data){
    pdx.transaction({subtype : 'pending',
        data : data});
}

export function sysPost(el , ev){
    pdx.info(EC_SYS, EA_POST, el, ev);
}

export function sysPostResult(el , ev){
    pdx.info(EC_SYS, EA_POST_RESULT, el, ev);
}

export function userShow(el , ev){
    pdx.info(EC_USER, EA_SHOW , el, ev);
}

export function userShowPaymentOptions(ev_values_arr){
    //ev_options is an array with possible values of
    // pay monthly
    // pay in full
    // deposit
    // hold
    // other
    // All in the order they were shown in the UI
  pdx.info(EC_USER, EA_SHOW, EL_MWEB, {payment_options : ev_values_arr});
}

export function fromPricingDirect(request) {
  let ev = {};
  ev[EV_QUERY] = request;
  ev[EV_LOCALIZATION] = (localization.getLocale()) ? localization.getLocale() : Locale().getLocale();
  pdx.info(EC_SYS, EA_POST, EL_FROM_PRICES, ev);
}

export function APIload(ev){
  //ev tripInfo stripped off PII
  pdx.info(EC_SYS,EA_LOAD , EL_API,ev);
}

export function APIOnChange(ev){
  //ev has ecode reasons
  pdx.info(EC_SYS, EA_CHANGE, EL_API,ev);
}

export function xhrFail(el, ev){
  // ev has timeout / fail
  // el marketing / malu
  pdx.info(EC_SYS, K_FAIL,  el, ev);
}

export function iframeBehaviour (ev){
  pdx.info(EC_SYS, EA_CHANGE, EL_IFRAME, ev);
}
